export default {
    codecommit: {
        nivel: "basico",
        cuando: ["Repositorios Git privados dentro de tu cuenta de AWS.", "Permisos con IAM y revisión por pull requests.", "Integración con CodePipeline y CodeBuild."],
        evita: ["Si tu equipo ya usa GitHub, GitLab o Bitbucket: úsalos con CodePipeline.", "AWS ha anunciado cambios en su disponibilidad para clientes nuevos: confirma su estado actual antes de elegirlo."],
        alt: [["codepipeline", "Funciona con otros repositorios."], ["amplify", "Se conecta directo a GitHub y similares."]],
        cobro: "Por usuario activo al mes con capa gratuita, más almacenamiento y solicitudes sobre los límites incluidos.",
        con: ["codepipeline", "codebuild", "iam"],
        quiz: { p: "¿Qué es un pull request?", o: ["Una propuesta de cambio que otros revisan antes de fusionar", "Un respaldo", "Una base de datos"], c: 0, e: "Permite revisar y comentar el código antes de integrarlo." },
    },
    codebuild: {
        nivel: "intermedio",
        cuando: ["Compilar y probar código sin mantener servidores de CI.", "Builds paralelos bajo demanda.", "Construir y subir imágenes de contenedor."],
        evita: ["Si ya tienes Jenkins o GitHub Actions funcionando bien."],
        alt: [["codepipeline", "Orquesta las etapas, incluida la compilación."]],
        cobro: "Por minuto de build según el tamaño del entorno de cómputo.",
        con: ["codecommit", "codepipeline", "ecr", "s3"],
        quiz: { p: "¿Qué archivo define los pasos de un build?", o: ["buildspec", "Dockerfile.exe", "index.html"], c: 0, e: "El buildspec describe fases, comandos y artefactos." },
    },
    codedeploy: {
        nivel: "intermedio",
        cuando: ["Desplegar a EC2, ECS, Lambda o servidores locales.", "Despliegues graduales o blue/green con reversión automática.", "Evitar caídas al actualizar."],
        evita: ["Infraestructura inmutable con CloudFormation o contenedores: puede no hacer falta."],
        alt: [["beanstalk", "Despliegue integrado en su entorno."], ["ecs", "Despliegues propios de ECS."]],
        cobro: "Sin costo para EC2, Lambda y ECS; los servidores locales se cobran por actualización.",
        con: ["ec2", "ecs", "lambda", "codepipeline"],
        quiz: { p: "¿Qué hace un despliegue blue/green?", o: ["Levanta la nueva versión en paralelo y cambia el tráfico", "Apaga todo y reinicia", "Borra la base"], c: 0, e: "Permite volver atrás rápido si algo sale mal." },
    },
    codepipeline: {
        nivel: "intermedio",
        cuando: ["Automatizar el camino del código a producción.", "Etapas con pruebas y aprobación manual.", "Entrega continua (CI/CD) en AWS."],
        evita: ["Si ya usas otra herramienta de CI/CD completa."],
        alt: [["codebuild", "Solo la parte de compilación."], ["amplify", "Para aplicaciones frontend."]],
        cobro: "Por pipeline activo al mes, con uno gratuito por cuenta.",
        con: ["codecommit", "codebuild", "codedeploy", "cloudformation"],
        quiz: { p: "¿Qué dispara la ejecución de un pipeline?", o: ["Un cambio en el repositorio u otro evento", "Una factura", "Un correo"], c: 0, e: "Normalmente un commit en la rama configurada." },
    },
    codeartifact: {
        nivel: "avanzado",
        cuando: ["Compartir librerías internas con tu equipo.", "Controlar de dónde vienen los paquetes de terceros.", "Usar npm, Maven, pip o NuGet."],
        evita: ["Proyectos pequeños con pocas dependencias."],
        alt: [["ecr", "Imágenes de contenedor, no paquetes."]],
        cobro: "Por GB almacenado al mes y por solicitudes.",
        con: ["codebuild", "iam", "s3"],
        quiz: { p: "¿Qué ventaja da CodeArtifact?", o: ["Un repositorio privado y controlado de paquetes", "Más velocidad de CPU", "Respaldo de bases"], c: 0, e: "Hace de intermediario seguro con los repositorios públicos." },
    },
    ecr: {
        nivel: "basico",
        cuando: ["Guardar las imágenes de tus contenedores.", "Escanear vulnerabilidades al subir.", "Integrar con ECS, EKS y Lambda."],
        evita: ["Imágenes públicas para todos: ECR Public o un registro público."],
        alt: [["s3", "Archivos genéricos."]],
        cobro: "Por GB almacenado al mes y por transferencia fuera de AWS.",
        con: ["ecs", "eks", "codebuild", "iam"],
        quiz: { p: "¿Qué se guarda en ECR?", o: ["Imágenes de contenedor", "Bases de datos", "Certificados"], c: 0, e: "Es el registro de imágenes." },
    },
    cloud9: {
        nivel: "basico",
        cuando: ["Programar desde el navegador con acceso directo a AWS.", "Entornos de práctica o talleres.", "Evitar instalar herramientas localmente."],
        evita: ["Desarrollo diario con tu editor habitual.", "AWS ha anunciado cambios en su disponibilidad para clientes nuevos: confirma su estado actual antes de elegirlo."],
        alt: [["amplify", "Para aplicaciones web."], ["ec2", "Un servidor propio."]],
        cobro: "Por la instancia EC2 que respalda el entorno mientras está encendida.",
        con: ["ec2", "iam", "codecommit"],
        quiz: { p: "¿Dónde corre un entorno de Cloud9?", o: ["En una instancia EC2", "En tu navegador solamente", "En Glacier"], c: 0, e: "El navegador es solo la pantalla." },
    },
    amplify: {
        nivel: "basico",
        cuando: ["Publicar sitios y aplicaciones web conectadas a GitHub.", "Entornos por rama (previsualizaciones).", "Backend sencillo para apps móviles."],
        evita: ["Arquitecturas complejas con muchos servicios propios."],
        alt: [["s3", "Sitio estático a mano."], ["apprunner", "APIs y servidores."], ["cloudfront", "Solo la entrega de contenido."]],
        cobro: "Por minuto de build, por GB almacenado y por GB entregado.",
        con: ["cloudfront", "s3", "cognito", "route53"],
        quiz: { p: "¿Qué hace Amplify con cada push a una rama?", o: ["Construye y publica esa rama", "Borra el repositorio", "Crea una base"], c: 0, e: "Es CI/CD integrado para frontend." },
    },
    cdk: {
        nivel: "avanzado",
        cuando: ["Definir infraestructura con TypeScript, Python u otros lenguajes.", "Reutilizar componentes con funciones y bucles.", "Aplicaciones sin servidores con SAM."],
        evita: ["Equipos sin experiencia en programación: CloudFormation directo o la consola."],
        alt: [["cloudformation", "Plantillas declarativas."]],
        cobro: "CDK y SAM no tienen costo; pagas lo que se crea.",
        con: ["cloudformation", "lambda", "apigw", "iam"],
        quiz: { p: "¿En qué se convierte el código de CDK al desplegar?", o: ["En una plantilla de CloudFormation", "En una imagen de disco", "En un certificado"], c: 0, e: "Se sintetiza a CloudFormation." },
    },
};
